// extracted by mini-css-extract-plugin
module.exports = {"old_price":"SummaryPrice_old_price__C9ibP"};